import React from 'react'
import { ZdsIcon, ZdsIconButton, ZdsTypography } from '@zera/components'
import { HeaderContainer, Profile, Avatar } from './styles'
import { useOpenCloseUpdater } from '~/context'

export const Header = (): JSX.Element => {
  const { close } = useOpenCloseUpdater()

  return (
    <HeaderContainer onClick={close}>
      <Profile>
        <Avatar>
          <ZdsIcon src="MiMaleDoctor" color="yellow100" />
        </Avatar>
        <ZdsTypography color="neutral100" variant="title400">
          IA Interativa
        </ZdsTypography>
      </Profile>
      <ZdsIconButton src="MiArrowheadDown" />
    </HeaderContainer>
  )
}
